import { render, staticRenderFns } from "./mattype_sel.vue?vue&type=template&id=7a2091c6&scoped=true&"
import script from "./mattype_sel.vue?vue&type=script&lang=js&"
export * from "./mattype_sel.vue?vue&type=script&lang=js&"
import style0 from "./mattype_sel.vue?vue&type=style&index=0&id=7a2091c6&scoped=true&lang=less&"
import style1 from "./mattype_sel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2091c6",
  null
  
)

export default component.exports